/* tslint:disable */
import {
  PaymentMethods,
  ChartOfAccount,
  IncomeInvoice,
  Lease
} from '../index';

declare var Object: any;
export interface TenantDepositInterface {
  "date_paid"?: Date;
  "amount": number;
  "lease_id": number;
  "deposit_type": string;
  "chart_of_account_id"?: number;
  "income_invoice_id"?: number;
  "status": string;
  "opening_balance": boolean;
  "id"?: number;
  "tenant_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  payment_methods?: PaymentMethods;
  chartOfAccount?: ChartOfAccount;
  incomeInvoice?: IncomeInvoice;
  lease?: Lease;
}

export class TenantDeposit implements TenantDepositInterface {
  "date_paid": Date;
  "amount": number;
  "lease_id": number;
  "deposit_type": string;
  "chart_of_account_id": number;
  "income_invoice_id": number;
  "status": string;
  "opening_balance": boolean;
  "id": number;
  "tenant_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  payment_methods: PaymentMethods;
  chartOfAccount: ChartOfAccount;
  incomeInvoice: IncomeInvoice;
  lease: Lease;
  constructor(data?: TenantDepositInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TenantDeposit`.
   */
  public static getModelName() {
    return "TenantDeposit";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TenantDeposit for dynamic purposes.
  **/
  public static factory(data: TenantDepositInterface): TenantDeposit{
    return new TenantDeposit(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TenantDeposit',
      plural: 'TenantDeposits',
      path: 'TenantDeposits',
      idName: 'id',
      properties: {
        "date_paid": {
          name: 'date_paid',
          type: 'Date'
        },
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "deposit_type": {
          name: 'deposit_type',
          type: 'string'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "income_invoice_id": {
          name: 'income_invoice_id',
          type: 'number',
          default: 0
        },
        "status": {
          name: 'status',
          type: 'string',
          default: 'ACTIVE'
        },
        "opening_balance": {
          name: 'opening_balance',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "tenant_id": {
          name: 'tenant_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        payment_methods: {
          name: 'payment_methods',
          type: 'PaymentMethods',
          model: 'PaymentMethods',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'payment_method'
        },
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chart_of_account_id',
          keyTo: 'id'
        },
        incomeInvoice: {
          name: 'incomeInvoice',
          type: 'IncomeInvoice',
          model: 'IncomeInvoice',
          relationType: 'belongsTo',
                  keyFrom: 'income_invoice_id',
          keyTo: 'id'
        },
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'lease_id',
          keyTo: 'id'
        },
      }
    }
  }
}
